import { render, staticRenderFns } from "./ModalRule.vue?vue&type=template&id=f5c8a9a6&"
import script from "./ModalRule.js?vue&type=script&lang=js&"
export * from "./ModalRule.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports